// relative
import type { ReadUnitDto } from '../types';

function getDefaultVisibleDataTypes(
  units: ReadUnitDto[],
  dataTypes: string[] = [],
): string[] {
  let visibleDataTypes: string[] = [];

  for (const unit of units) {
    const unitDataTypes =
      unit?.RecordedDataTypes?.flatMap((rdt) => rdt.DataTypes ?? []) ?? [];
    for (const unitSensor of unit.UnitSensors ?? []) {
      const sensor = unitSensor.Sensor;
      if (!sensor) {
        visibleDataTypes.push(...unitDataTypes);
        continue;
      }
      const sensorType = sensor.SensorType;
      if (!sensorType) {
        visibleDataTypes.push(...unitDataTypes);
        continue;
      }

      switch (sensorType) {
        case 'PowerMoniMain':
          visibleDataTypes.push('power');
          break;
        case 'PowerMoniSpot':
          if (sensor.CalibrationType !== 'Level1') {
            visibleDataTypes.push('power');
          } else {
            visibleDataTypes.push('uncalibrated-current');
          }
          break;
        case 'HeatMoniSpot':
          visibleDataTypes.push('temperature');
          break;
        case 'TempMoniSpot':
          visibleDataTypes.push('temperature');
          break;
        case 'FlowMoniVolume':
          visibleDataTypes.push('flow-speed');
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('temperature');
          break;
        case 'TempMoniDC':
          visibleDataTypes.push('temperature');
          break;
        case 'FlowMoniEnergy':
          visibleDataTypes.push('accumulated-flow');
          visibleDataTypes.push('temperature');
          visibleDataTypes.push('indicative-consumption');
          break;
        case 'GatewaySensor':
          visibleDataTypes.push('temperature');
          visibleDataTypes.push('humidity');
          visibleDataTypes.push('co2-consumption');
          break;
        default:
          visibleDataTypes = dataTypes;
      }
    }
  }

  if (visibleDataTypes.length === 0) {
    visibleDataTypes = dataTypes;
  }

  return Array.from(new Set(visibleDataTypes));
}

export default getDefaultVisibleDataTypes;
